import { getMeta } from './meta.js';
import { showConfirmBox, showMessageBox, MessageBoxFrame } from './msgbox.jsx';
import xhr from './xhr.js';

const moveButtons = Array.from(document.querySelectorAll('.js-forum-topic-move'));
for(const moveButton of moveButtons) {
    moveButton.addEventListener('click', async ev => {
        if(moveButton.disabled)
            return;

        const statusText = moveButton.querySelector('.js-action-text') ?? moveButton;

        statusText.textContent = 'Moving...';
        for(const button of moveButtons)
            button.disabled = true;

        try {
            const forumCategoriesUrl = getMeta('url-forum-categories');
            const forumTopicMoveUrl = getMeta('url-forum-topic-move');
            if(typeof forumCategoriesUrl !== 'string' || typeof forumTopicMoveUrl !== 'string') {
                await showMessageBox('Could not discover required URL!', 'Error while moving topic');
                return;
            }

            const { status: listStatus, body: list } = await xhr.get(forumCategoriesUrl, { authed: true, type: 'json' });
            if(listStatus !== 200 || !Array.isArray(list)) {
                await showMessageBox('Could not retrieve category list!', 'Error while moving topic');
                return;
            }

            let fields;
            for(;;) {
                fields = await new Promise((resolve, reject) => {
                    let container;
                    const form = <form class="forum-modal-form" onsubmit={ev => {
                        ev.preventDefault();
                        container.remove();

                        const fields = {};
                        for(const field of form.elements)
                            if(field.name)
                                fields[field.name] = field.value;

                        resolve(fields);
                    }}>
                        <label class="forum-modal-field">
                            <div class="forum-modal-field-label">Category</div>
                            <div class="forum-modal-field-value">
                                <select class="input__select forum-modal-field-value-text" name="category">
                                    {...list.map(item => {
                                        if(item === '---')
                                            return <hr />;
                                        return <option value={item.id ?? ''}>{item.name ?? `${item.pfx}Inaccessible category`}</option>;
                                    })}
                                </select>
                            </div>
                        </label>

                        <div class="forum-modal-buttons">
                            <button class="input__button">Move</button>
                            <button class="input__button input__button--destroy" type="button" onclick={() => {
                                container.remove();
                                reject();
                            }}>Cancel</button>
                        </div>
                    </form>;

                    container = <MessageBoxFrame title="Select a category to move this topic to">{form}</MessageBoxFrame>;
                    container.classList.add('forum-modal');
                    document.body.appendChild(container);

                    form.elements[0]?.focus();
                });

                const { status: patchStatus, body: patchBody } = await xhr.patch(forumTopicMoveUrl, { authed: true, csrf: true, type: 'json' }, fields);
                if(patchStatus === 204) {
                    location.reload();
                    break;
                } else await showMessageBox(patchBody?.error?.text, 'Error while moving topic');
            }
        } finally {
            statusText.textContent = 'Move';
            for(const button of moveButtons)
                button.disabled = false;
        }
    });
}
